<template>
  <div class="container-fluid py-3 px-4">

    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-gear-fill display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            PUNTO DE VENTA
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            MANTENIMIENTO
          </p>
        </div>
      </div>
    </div>

    <div class="row g-3 mx-2">

      <!-- 🧾 FORMULARIO -->
      <div class="col-12 col-lg-4">
        <form class="mt-2" @submit.prevent="GrabarEntrevista">
          <div class="border border-1 rounded-3 p-3 mb-3 shadow-sm">

            <div class="row gy-3">

              <!-- CÓDIGO -->
              <div class="col-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-upc-scan text-primary fs-6"></i>
                  CÓDIGO:
                </label>
                <input required v-model="codigo" type="text" class="form-control tamaños" maxlength="6"
                  @input="validarEntrada" />
              </div>

              <!-- NOMBRE -->
              <div class="col-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-person-lines-fill text-success fs-6"></i>
                  NOMBRE:
                </label>
                <input required v-model="nombre" type="text" class="form-control tamaños" @input="validarEntrada" />
              </div>

              <!-- DIRECCIÓN -->
              <div class="col-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-geo-alt-fill text-warning fs-6"></i>
                  DIRECCIÓN:
                </label>
                <input required v-model="direccion" type="text" class="form-control tamaños" @input="validarEntrada" />
              </div>

              <!-- DEPARTAMENTO -->
              <div class="col-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-globe2 text-info fs-6"></i>
                  DEPARTAMENTO:
                </label>
                <select required @change="Depa($event)" class="form-control text-secondary tamaños">
                  <option disabled selected value="">
                    --SELECCIONAR DEPARTAMENTO--
                  </option>
                  <option v-for="departamentos in departamento" :value="departamentos.idParametro"
                    :key="departamentos.id">
                    {{ departamentos.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- PROVINCIA -->
              <div class="col-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-building text-secondary fs-6"></i>
                  PROVINCIA:
                </label>
                <select required @change="Province($event)" class="form-control text-secondary tamaños">
                  <option disabled selected value="">
                    --SELECCIONAR PROVINCIA--
                  </option>
                  <option v-for="provincia in provincias" :value="provincia.idParametro" :key="provincia.id">
                    {{ provincia.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- DISTRITO -->
              <div class="col-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-geo-fill text-primary fs-6"></i>
                  DISTRITO:
                </label>
                <select required @change="DistritoDes($event)" class="form-control text-secondary tamaños">
                  <option disabled selected value="">
                    --SELECCIONAR DISTRITO--
                  </option>
                  <option v-for="distritos in distrito" :value="distritos.parCorrelativo" :key="distritos.id">
                    {{ distritos.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- ESTADO -->
              <div class="col-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-toggle-on text-success fs-6"></i>
                  ESTADO:
                </label>
                <select required @change="estado = $event.target.value" class="form-select tamaños mt-2">
                  <option disabled value="">--SELECCIONAR ESTADO--</option>
                  <option :value="true">ACTIVO</option>
                  <option :value="false">INACTIVO</option>
                </select>
              </div>

              <!-- GUARDAR -->
              <div class="d-flex justify-content-center mt-3">
                <button type="submit" class="btn btn-success mx-2 mb-2">
                  <i class="bi bi-floppy fs-6"></i>
                </button>
              </div>

            </div>

          </div>
        </form>
      </div>

      <!-- 🗺️ GOOGLE MAPS -->
      <div class="col-12 col-lg-8">
        <div class="border border-1 rounded-3 p-3 shadow-sm h-100">
          <gmap-map :center="{ lat: 37.7749, lng: -122.4194 }" :zoom="13" style="width: 100%; height: 360px;">
          </gmap-map>
        </div>
      </div>

      <div class="border border-1 rounded-3 p-3 mb-2 shadow-sm">
        <div class="d-flex justify-content-end mb-4">
          <label for="" class="mt-4 me-2 tamaños"> BUSCAR:</label>

          <input class="form-control form-control-lg w-25 mt-3 tamaños" type="text" placeholder="TIPO DE ENTREVISTA..."
            v-model="filterField" @input="handleFilter" />
        </div>
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr class="bg-solimano-table text-white text-center tamaño2 text-nowrap">
                <th scope="col">ID</th>
                <th scope="col">TIENDA</th>
                <th scope="col">DIRECCION</th>
                <th scope="col">UBIGEO</th>
                <th>ACCION</th>
              </tr>
            </thead>
            <tbody>
              <!-- Spinner mientras se cargan los datos -->
              <tr v-if="loading">
                <td colspan="5" class="text-center py-5">
                  <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                    <span class="visually-hidden">Cargando...</span>
                  </div>
                </td>
              </tr>

              <!-- Filas de información -->
              <tr v-else v-for="post in informacionPaginada" :key="post.idTienda"
                class="tamaños text-nowrap align-middle">
                <td class="text-center fw-bold">{{ post.idTienda }}</td>
                <td class="text-start"><i class="bi bi-shop text-success me-2"></i>{{ post.tieNombre }}</td>
                <td class="text-center"><i class="bi bi-geo-alt-fill text-danger me-2"></i>{{ post.direccion }}</td>
                <td class="text-center"><i class="bi bi-map text-warning me-2"></i>{{ post.ubigeo }}</td>
                <td class="text-center">
                  <div class="mx-2 d-flex justify-content-center align-items-center gap-2">
                    <b-button class="bg-success border-0" v-b-modal.modal-center
                      @click="getAttributesXid(post.idTienda)">
                      <i class="bi bi-pencil-square"></i>
                    </b-button>
                    <button disabled class="btn btn-danger">
                      <i class="bi bi-trash3-fill"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>

          </table>

          <div>
            <b-modal id="modal-center" centered title="MODIFICAR PUNTO DE VENTA" @ok="ModificarTienda">

              <div class="container">

                <!-- CODIGO -->
                <div class="col-12 mt-2">
                  <label class="tamaño fw-bold d-flex align-items-center gap-2">
                    <i class="bi bi-upc-scan text-primary fs-5"></i> CÓDIGO:
                  </label>
                  <input required v-model="codigoEditar" maxlength="6" type="text" class="form-control py-2"
                    @input="validarEntrada" />
                </div>

                <!-- NOMBRE -->
                <div class="col-12 mt-3">
                  <label class="tamaño fw-bold d-flex align-items-center gap-2">
                    <i class="bi bi-card-text text-primary fs-5"></i> NOMBRE:
                  </label>
                  <input required v-model="nombreEditar" type="text" class="form-control py-2"
                    @input="validarEntrada" />
                </div>

                <!-- DIRECCION -->
                <div class="col-12 mt-3">
                  <label class="tamaño fw-bold d-flex align-items-center gap-2">
                    <i class="bi bi-geo-alt-fill text-danger fs-5"></i> DIRECCIÓN:
                  </label>
                  <input required v-model="direccionEditar" type="text" class="form-control py-2"
                    @input="validarEntrada" />
                </div>

                <!-- DEPARTAMENTO -->
                <div class="col-12 mt-3">
                  <label class="tamaño fw-bold d-flex align-items-center gap-2">
                    <i class="bi bi-building text-primary fs-5"></i> DEPARTAMENTO:
                  </label>
                  <select required @change="Depa($event)" class="form-control text-secondary py-2">
                    <option selected disabled value="">{{ desDepartamento }}</option>
                    <option v-for="departamentos in departamento" :key="departamentos.id"
                      :value="departamentos.idParametro">
                      {{ departamentos.parDescripcion }}
                    </option>
                  </select>
                </div>

                <!-- PROVINCIA -->
                <div class="col-12 mt-3">
                  <label class="tamaño fw-bold d-flex align-items-center gap-2">
                    <i class="bi bi-map text-success fs-5"></i> PROVINCIA:
                  </label>
                  <select required @change="Province($event)" class="form-control text-secondary py-2">
                    <option selected disabled value="">{{ desProvincia }}</option>
                    <option v-for="provincia in provincias" :key="provincia.id" :value="provincia.idParametro">
                      {{ provincia.parDescripcion }}
                    </option>
                  </select>
                </div>

                <!-- DISTRITO -->
                <div class="col-12 mt-3 mb-1">
                  <label class="tamaño fw-bold d-flex align-items-center gap-2">
                    <i class="bi bi-flag text-warning fs-5"></i> DISTRITO:
                  </label>
                  <select required @change="DistritoDes($event)" class="form-control text-secondary py-2">
                    <option selected disabled value="">{{ desDistrito }}</option>
                    <option v-for="distritos in distrito" :key="distritos.id" :value="distritos.parCorrelativo">
                      {{ distritos.parDescripcion }}
                    </option>
                  </select>
                </div>
              </div>
            </b-modal>
          </div>
        </div>
        <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">

          <!-- Ir a primera página -->
          <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
            <i class="bi bi-chevron-double-left"></i>
          </button>

          <!-- Retroceder -->
          <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
            <i class="bi bi-chevron-left"></i>
          </button>

          <span class="pagination-info fw-bold">
            Página {{ currentPage }} de {{ totalPages }}
          </span>

          <!-- Avanzar -->
          <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
            <i class="bi bi-chevron-right"></i>
          </button>

          <!-- Última página -->
          <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
            :disabled="currentPage === totalPages">
            <i class="bi bi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "SolimanoLogPuntosDeVenta",

  data() {
    return {
      currentPage: 1,
      itemsPerPage: 5,
      filterField: "",
      loading: false,

      departamento: [],
      provincias: [],
      distrito: [],

      codProvincia: "",
      codDepartamento: "",
      solUbigeo: "",
      codigo: "",
      nombre: "",
      direccion: "",
      estado: Boolean,

      idTienda: "",
      codigoEditar: "",
      nombreEditar: "",
      direccionEditar: "",
      desDepartamento: "",
      desProvincia: "",
      desDistrito: "",

      informacion: [],
      ubicacionActual: null,
      watchId: null,
    };
  },

  // ---------------------------------
  // COMPUTED (BIEN UBICADO AQUÍ)
  // ---------------------------------
  computed: {
    informacionFiltrada() {
      if (!this.filterField) return this.informacion;

      const texto = this.filterField.toLowerCase();

      return this.informacion.filter((d) =>
        String(d.codTienda).toLowerCase().includes(texto) ||
        d.tieNombre?.toLowerCase().includes(texto) ||
        d.direccion?.toLowerCase().includes(texto) ||
        d.desDepartamento?.toLowerCase().includes(texto) ||
        d.desProvincia?.toLowerCase().includes(texto) ||
        d.desDistrito?.toLowerCase().includes(texto)
      );
    },

    informacionPaginada() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.informacionFiltrada.slice(start, start + this.itemsPerPage);
    },

    totalPages() {
      return Math.ceil(this.informacionFiltrada.length / this.itemsPerPage);
    }
  },

  // ---------------------------------
  // LIFECYCLE
  // ---------------------------------
  async mounted() {
    let depa = await this.axios.get("ParametroData/Parametro/350");
    this.departamento = depa.data;
  },

  created() {
    this.cambiarEstadoNavbar();
    this.getAttributes();
  },

  // ---------------------------------
  // MÉTODOS
  // ---------------------------------
  methods: {
    handleFilter() {
      this.loading = true; // mostrar spinner
      // Simular un pequeño delay para ver el spinner
      setTimeout(() => {
        this.loading = false;
      }, 800); // 0.3 segundos
    },
    // tu método getAttributes y otros métodos
    validarEntrada() {
      this.codigo = this.codigo.replace(/[^a-zA-Z0-9\s]/g, "");
      this.nombre = this.nombre.replace(/[^a-zA-Z0-9\s]/g, "");
      this.direccion = this.direccion.replace(/[^a-zA-Z0-9\s]/g, "");

      this.codigoEditar = this.codigoEditar.replace(/[^a-zA-Z0-9\s]/g, "");
      this.nombreEditar = this.nombreEditar.replace(/[^a-zA-Z0-9\s]/g, "");
      this.direccionEditar = this.direccionEditar.replace(/[^a-zA-Z0-9\s]/g, "");
    },

    GrabarEntrevista() {
      const from = {
        codTienda: this.codigo,
        tieNombre: this.nombre,
        ubigeo: this.solUbigeo,
        direccion: this.direccion,
        estadoPuntoVenta: !!this.estado,
      };

      this.axios.post(`Asistencia/RegistrarPuntoVenta`, from)
        .then((r) => {
          if (r.data) {
            Swal.fire({
              position: "top-center",
              icon: "success",
              title: "Se registró cambios",
              showConfirmButton: false,
              timer: 1500,
            });
            this.getAttributes();
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: `${error.response.data}`,
          });
        });
    },

    getAttributes() {
      this.loading = true;
      this.axios.get(`Asistencia/ListarPuntoVenta`)
        .then((r) => {
          this.informacion = r.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getAttributesXid(idTienda) {
      this.axios
        .get(`Asistencia/ListarPuntoVentaxid?idTienda=${idTienda}`)
        .then((r) => {
          this.idTienda = idTienda;
          this.codigoEditar = r.data[0].codTienda;
          this.nombreEditar = r.data[0].tieNombre;
          this.direccionEditar = r.data[0].direccion;
          this.desDepartamento = r.data[0].desDepartamento;
          this.desProvincia = r.data[0].desProvincia;
          this.desDistrito = r.data[0].desDistrito;
          this.solUbigeo = r.data[0].codDistrito;
        });
    },

    ModificarTienda() {
      const from = {
        idTienda: this.idTienda,
        codTienda: this.codigoEditar,
        tieNombre: this.nombreEditar,
        ubigeo: this.solUbigeo,
        direccion: this.direccionEditar,
        estadoPuntoVenta: true,
      };

      this.axios.put(`Asistencia/ModificarPuntoVenta`, from)
        .then((r) => {
          if (r.data) {
            Swal.fire({
              position: "top-center",
              icon: "success",
              title: "Se realizó cambios",
              showConfirmButton: false,
              timer: 2500,
            });
            this.getAttributes();
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: `${error.response.data}`,
          });
        });
    },

    cambiarEstadoNavbar() {
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    Depa(event) {
      this.axios
        .get(`ParametroData/ParametroDepxProv/${event.target.value}`)
        .then((r) => {
          this.codDepartamento = r.data[0].parCorrelativo;
        });

      this.axios
        .get(`ParametroData/Parametro/${event.target.value}`)
        .then((r) => {
          this.provincias = r.data;
        });
    },

    Province(event) {
      this.axios
        .get(`ParametroData/ParametroDepxProv/${event.target.value}`)
        .then((r) => {
          this.codProvincia = r.data[0].parCorrelativo;
        });

      this.axios.get(`DistritoData/Listar/${event.target.value}`)
        .then((r) => {
          this.distrito = r.data;
        });
    },

    DistritoDes(event) {
      this.solUbigeo = event.target.value;
    }
  }
};
</script>


<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 1%;
  margin-bottom: 1%;
  padding-bottom: 2%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 1%;
  margin-right: 1%;
  height: auto;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: hidden;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.tamaños {
  font-size: 0.65rem;
}

.tamaño2 {
  font-size: 0.65rem;
  font-weight: 800;
}

.titulo {
  color: #0080c8;
  text-decoration: underline;
}

.bg-solimano {
  border-color: #0080c8;
  border-width: 2px;
}

.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}
.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}
.reducirTamaño {
  font-size: 0.65rem;
}
</style>